<template>
    <section>
        <h2>Not found</h2>
        
        <p>Can't access this section with this account</p>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>